<mcg-loader [message]="translate('Cargando_datos')" [showLoader]="isLoading"></mcg-loader>
<mcg-window #windowsListInstall [actions]="actions" (actionButtonClicked)="actionButtonClicked($event)"
    (windowClosed)="onClose()" [title]="titleWindow + ' (' + countPartialResults() + ')'">
    <app-header #header [exportar]="true" [buscador]="true" (eventFilter)="onFilter()" [filtro]="true"
        [resetFiltro]="true" (eventExportar)="exportToExcel()" (eventBuscador)="onBuscar()"
        (eventResetFilter)="onResetFilter()">
    </app-header>
    <div class="grid-container">
        <div class="grid-wrapper">
            <jqxGrid #gridListInstall [theme]="theme" [width]="'100%'" [height]="'99%'" [source]="dataAdapter"
                [appCellClick] [columnsresize]="true" [localization]="langGrid" [filterable]="true" [columns]="columns"
                [showrowlines]="false" [showcolumnlines]="true" [sortable]="true" [groupable]="true"
                [groupsheaderheight]="25" (onBindingcomplete)="onGridDataUpdate()" (onFilter)="onGridDataUpdate()"
                [editable]="false" [altrows]="true" [rowsheight]="20" [columnsheight]="20" [editable]="false"
                [enablebrowserselection]="true" [filter]="filter" [updatefilterconditions]="updatefilterconditions"
                [columnmenuopening]='columnmenuopening'>
            </jqxGrid>
        </div>
    </div>
</mcg-window>
